import { SpecialCalculationCostFilterParams } from '@/types/special-calculation-cost';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AppAdminFormLabel, AppButton, SearchTextField } from '../atoms';
import { Download, Search } from '../atoms/AppIcon';
import { RA2NDatePicker } from './RA2NDatePicker';
import { useTheme } from '@/shared/providers/theme';

interface AdminSpecialCalculationCostFilterProps {
  onSearch?: (filters: SpecialCalculationCostFilterParams) => void;
  onCsvDownload?: (filters: SpecialCalculationCostFilterParams) => void;
  isCsvLoading?: boolean;
}

const AdminSpecialCalculationCostFilter = ({
  onSearch,
  onCsvDownload,
  isCsvLoading,
}: AdminSpecialCalculationCostFilterProps) => {
  const [searchParams] = useSearchParams();
  const { colors } = useTheme();

  const [filters, setFilters] = useState<SpecialCalculationCostFilterParams>({
    search_insurer_number: searchParams.get('search_insurer_number') || '',
    search_insurer_name: searchParams.get('search_insurer_name') || '',
    available_date: searchParams.get('available_date') || '',
  });

  useEffect(() => {
    setFilters({
      search_insurer_number: searchParams.get('search_insurer_number') || '',
      search_insurer_name: searchParams.get('search_insurer_name') || '',
      available_date: searchParams.get('available_date') || '',
    });
  }, [searchParams]);

  const handleChange = (key: keyof SpecialCalculationCostFilterParams, value: string) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className="bg-white rounded-md border p-4 mb-4">
      <div className="flex gap-4 items-end flex-wrap">
        <div className="flex-1 min-w-40">
          <AppAdminFormLabel label="保険者番号" />
          <SearchTextField
            placeholder="保険者番号"
            value={filters.search_insurer_number}
            onChange={e => handleChange('search_insurer_number', e.target.value)}
            data-skip-enter-nav
            onPressEnter={() => onSearch?.(filters)}
          />
        </div>
        <div className="flex-1 min-w-40">
          <AppAdminFormLabel label="保険者名称" />
          <SearchTextField
            placeholder="保険者名称"
            value={filters.search_insurer_name}
            onChange={e => handleChange('search_insurer_name', e.target.value)}
            data-skip-enter-nav
            onPressEnter={() => onSearch?.(filters)}
          />
        </div>
        <div className="flex-1 min-w-40">
          <AppAdminFormLabel label="基準日" />
          <RA2NDatePicker
            placeholder="基準日"
            value={filters.available_date}
            onChange={val => handleChange('available_date', val)}
            onEnter={() => onSearch?.(filters)}
          />
        </div>
        <div className="flex gap-2 items-end">
          <AppButton icon={<Search />} type="primary" onClick={() => onSearch?.(filters)}>
            検索
          </AppButton>
          <AppButton
            icon={<Download />}
            type="primary"
            style={
              {
                backgroundColor: colors.secondary,
                ['--action-bg-hover' as string]: colors.secondaryHover,
              } as React.CSSProperties
            }
            className="hover:!bg-[var(--action-bg-hover)]"
            loading={isCsvLoading}
            onClick={() => onCsvDownload?.(filters)}
          >
            CSV
          </AppButton>
        </div>
      </div>
    </div>
  );
};

export default AdminSpecialCalculationCostFilter;
